import React from "react";
import PropTypes from "prop-types";
import { Button } from "@learningblocks/shared-components";
import "./style.scss";

/*
 * NextSectionBlock
 *  - Button to navigate to next section.
 */

export function NextSectionBlock(props) {
  const onClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    props.toNextSection(props.nextSection);
  };
  if (props.complete) {
    return (
      <div className="nextSectionBlock">
        <Button className="nextSectionButton" onClick={onClick}>
          Next Section
        </Button>
      </div>
    );
  } else return null;
}

NextSectionBlock.propTypes = {
  /**
   * Boolean to specify if current DesignSlide in view is complete.
   */
  complete: PropTypes.bool.isRequired,
  /**
   * Function to invoke when next slide button is pressed.
   */
  toNextSection: PropTypes.func.isRequired,
};
